/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasConfirmModal
 * @restrict E
 * @description Widget che visualizza una finestra di conferma con pulsanti annulla / conferma. Opzionalmente è possibile specificare testi alternativi
 * @param {string} headerText - Testo da visualizzare nell'intestazione al posto del testo standard
 * @param {string} bodyText - Testo da visualizzare nel corpo della finestra al posto del testo standard
 * @param {string} cancelText - Testo da visualizzare nel pulsante "Annulla" al posto del testo standard
 * @param {string} confirmText - Testo da visualizzare nel pulsante "Conferma" al posto del testo standard
 * @param {function} optionSelected - Funzione eseguita alla selezione di una delle opzioni tra "Annulla" o "Conferma"
 */
(function() {
	"use strict";
	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasConfirmModal", [ 'CONSTANTS', function(CONSTANTS) {
		
		var controller = function($scope, labelSrvc) {
			$scope.msg = labelSrvc.getLabel;

			if (!$scope.headerText) {
				$scope.headerText = $scope.msg('label.confirmmodal.header');
			}
			
			if (!$scope.bodyText) {
				$scope.bodyText = $scope.msg('label.confirmmodal.body');
			}
			
			if (!$scope.cancelText) {
				$scope.cancelText = $scope.msg('button.confirmmodal.cancel');
			}
			
			if (!$scope.confirmText) {
				$scope.confirmText = $scope.msg('button.confirmmodal.confirm');
			}
			
			var self = this;

            /**
			 * @ngdoc method
			 * @name selectOption
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasConfirmModal
			 * @description Chiude la finestra di conferma, passando il valore selezionato alla callback "optionSelected" impostata
			 */
            this.selectOption = function (optionValue) {            	
            	if (typeof $scope.optionSelected === 'function') {
            		$scope.optionSelected({ result: optionValue });
            	}
            };
		};

		controller.$inject = ['$scope', 'LabelSrvc'];
		
		return {
			restrict : "E",
			scope : {
				headerText: '<',
				bodyText: '<',
				cancelText: '<',
				confirmText: '<',
				optionSelected: '&'
			},
			templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasConfirmModal/creasConfirmModal.html",
			controller: controller,
			controllerAs: "creasConfirmModalCtrl",
		};
	}]);
}());


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasConfirmModal/creasConfirmModalDrct.js
// module id = 11
// module chunks = 0 1